import * as login from './moudules/login';
import * as user from './moudules/user';
import * as adminUser from './moudules/adminUser';
import * as integralItem from './moudules/integralItem';
import * as propaganda from './moudules/propaganda';


export default {
    login,
    integralItem,
    user,
    adminUser,
    propaganda,
}